export default function Excel_Format_Colors() {
  return <div>Excel_Format_Colors</div>;
}
